var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"theme-color",staticStyle:{"height":"100%"},attrs:{"fluid":""}},[_c('UserManagement',{staticClass:"dialog mb-sm-5",class:{ xs: _vm.$vuetify.breakpoint.xsOnly }})],1)}
var staticRenderFns = []

export { render, staticRenderFns }